import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=5dc22a39&scoped=true&"
import script from "./TOS.vue?vue&type=script&lang=ts&"
export * from "./TOS.vue?vue&type=script&lang=ts&"
import style0 from "./TOS.vue?vue&type=style&index=0&id=5dc22a39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc22a39",
  null
  
)

export default component.exports